<template>
  <div>
    <template v-if="isEditMode">
      <b-form-input
          style="background-color: #c9daf8; color: #36342c; border: none"
          v-model="displayText"
          placeholder="Enter at least 10 characters"
      />
    </template>
    <div v-else>
      <h4>
        {{ displayText }}
      </h4>
    </div>
    <b-icon
        @click="handleEditClick"
        style="cursor:pointer;"
        icon="pencil"
        scale="1"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HeartBeat_CarePlan_Block_Texts",
  components: {},
  created(){},
  beforeMount() {},
  mounted() {},
  props: {
    texts: {
      type: Array,
      default: () => {
        return []
      }
    },
    heartbeat: {
      type: Object,
      default: () => {
        return {};
      }
    },
    info: {
      type: Array,
      default: () => {
        return [];
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    sectionId: {
      type: String,
      default: 'none'
    },
    planId: {
      type: String,
      default: 'none'
    },
  },
  computed: {
    ...mapGetters({}),
    text() {
      return this.texts && Array.isArray(this.texts) ?
          this.texts[0]: [];
    },
    displayText() {
      return this.text ? this.text.text : "";
    },
  },
  methods: {
    handleFeedbackThumbsUp(isLiked){
      //Update Feedback
      //PopUp Modal for Additional Comments
      this.addFeedbackThumbsUp(isLiked);
    },
    addFeedbackThumbsUp(isLiked) {
      const profileBy = this.profileBy();

      const feedback = {
        isLiked: isLiked,
        _created_by: profileBy,
        _created_at: new Date()
      };

      if (this.comment) feedback.comment = this.comment;

      this.$store
          .dispatch("provider/addSectionTrackForProviderIdPlanIdDocId", {
            sectionId:  this.sectionId,
            trackProperty: 'feedbacks',
            payload: feedback,
            providerId: this.providerId,
            planId: this.planId,
            docId: this.docId,
            updatedBy:{}
          })
          .then(({ length }) => {
            if (length) {
              this.maxcp = length;
              this.cpIdx = length - 1;
            }
          })
          .catch(err => {});
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
            ? `${this.profile.firstname} ${this.profile.lastname}`
            : null,
        imgURL: this.profile ? this.profile.imgURL : null,
        comment: null
      }
    },
    handleEditClick(){
      this.isEditMode = !this.isEditMode;
    }
  },
  data() {
    return {
      isEditMode: false,
      sectionText: null
    };
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>